

import JSZip from 'jszip';
import {saveAs} from 'file-saver';
import Utils from './utils';
import {ESDIconPackManifest} from './ESDIconPackManifest';
import {ESDImageScaler} from './ESDImageScaler.js';
import {ELGEventEmitter} from './ELGEventEmitter';

const MRequiredSizeFactor = 36;


// const placeholder_preview = "data:image/svg+xml,%3Csvg width='1280' height='800' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h1280v800H0z' fill='%23000' fill-rule='evenodd' fill-opacity='.25'/%3E%3C/svg%3E";
// const ipmSVG = "data:image/svg+xml,%3Csvg width='144' height='144' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath opacity='.1' d='M0 0h144v144H0z'/%3E%3Cpath d='M57.42 13c10.364 0 20.168 3.086 28.572 8.978a51.59 51.59 0 018.132 6.961l3.472-3.425 39.734 39.205-39.734 39.206-4.602-4.542a49.887 49.887 0 01-3.08 2.834C80.95 109.792 69.183 114 57.42 114c-13.445 0-26.05-5.33-35.574-14.87C12.322 89.593 7 76.968 7 63.5c0-13.467 5.322-26.092 14.846-35.63C31.37 18.33 43.975 13 57.42 13zm.28 9.82a40.08 40.08 0 00-26.033 9.542C22.417 39.695 16.5 50.919 16.5 63.5c0 20.611 15.882 37.582 36.288 39.763 1.612.215 3.25.335 4.912.356 8.684 0 16.807-2.805 23.81-7.855a40.876 40.876 0 004.17-3.596L57.863 64.719l29.356-28.965C79.801 27.644 69.194 22.82 57.7 22.82zM15.106 134v-2.4h-2.368v-7.2h2.368V122H8v2.4h2.369v7.2H8v2.4h7.106zm9.476-9.6V122h-4.738v2.4h4.738zm-4.738 7.2v-7.2h-2.369v7.2h2.37zm4.738 2.4v-2.4h-4.738v2.4h4.738zm9.475-9.6V122h-4.738v2.4h4.738zm-4.738 7.2v-7.2h-2.368v7.2h2.368zm7.107 0v-7.2h-2.369v7.2h2.369zm-2.369 2.4v-2.4h-4.738v2.4h4.738zm7.106 0v-7.2h2.37v-2.4h-2.37V122h-2.368v12h2.368zm7.107 0v-12H45.9v4.8h-2.369v2.4h2.37v4.8h2.368zm6.648-4.644v-2.4h-4.28v2.4h4.28zM59.656 134v-4.8h2.369v-2.4h-2.37v-2.4h2.37V122h-4.738v12h2.369zm4.738-7.2v-2.4h-2.37v2.4h2.37zm7.106-2.4V122h-2.369v2.4H71.5zm-2.369 9.6v-4.8H71.5v4.8h2.369v-9.6H71.5v2.4h-2.369v-2.4h-2.369v9.6h2.37zm14.213-9.6V122h-4.738v2.4h4.738zm-4.738 7.2v-7.2h-2.368v7.2h2.368zm4.738 2.4v-2.4h-4.738v2.4h4.738zm4.738 0v-4.8h2.369v-2.4h-2.37V122h-2.368v12h2.369zm4.737-7.2V122h-2.368v4.8h2.368zm0 7.2v-4.8h-2.368v4.8h2.368zm6.649-4.644v-2.4h-4.28v2.4h4.28zm4.737 4.644v-7.2h2.37v-2.4h-2.37V122h-2.368v12h2.368zm9.476 0v-12h-2.37v2.4h-2.368v2.4h2.369v7.2h2.369zm-4.743-4.8v-2.4h-2.369v2.4h2.369zm11.85-4.8V122h-2.37v2.4h2.37zm-2.37 9.6v-4.8h2.37v4.8h2.368v-9.6h-2.369v2.4h-2.369v-2.4h-2.369v9.6h2.37zm9.476 0v-7.2h2.368v-2.4h-2.368V122h-2.37v12h2.37zm7.106 0v-12h-2.369v4.8h-2.369v2.4h2.37v4.8H135z' fill='%23FFF'/%3E%3C/svg%3E";

// const ipmSVG = "data:image/svg+xml,%3Csvg width='144' height='144' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='1'%3E%3Cpath opacity='0' fill='%2300f' d='M0 0h144v144H0z'/%3E%3Cpath fill='%235e6271' d='M57.42 13c10.364 0 20.168 3.086 28.572 8.978a51.59 51.59 0 018.132 6.961l3.472-3.425 39.734 39.205-39.734 39.206-4.602-4.542a49.887 49.887 0 01-3.08 2.834C80.95 109.792 69.183 114 57.42 114c-13.445 0-26.05-5.33-35.574-14.87C12.322 89.593 7 76.968 7 63.5c0-13.467 5.322-26.092 14.846-35.63C31.37 18.33 43.975 13 57.42 13zm.28 9.82a40.08 40.08 0 00-26.033 9.542C22.417 39.695 16.5 50.919 16.5 63.5c0 20.611 15.882 37.582 36.288 39.763 1.612.215 3.25.335 4.912.356 8.684 0 16.807-2.805 23.81-7.855a40.876 40.876 0 004.17-3.596L57.863 64.719l29.356-28.965C79.801 27.644 69.194 22.82 57.7 22.82zM15.106 134v-2.4h-2.368v-7.2h2.368V122H8v2.4h2.369v7.2H8v2.4h7.106zm9.476-9.6V122h-4.738v2.4h4.738zm-4.738 7.2v-7.2h-2.369v7.2h2.37zm4.738 2.4v-2.4h-4.738v2.4h4.738zm9.475-9.6V122h-4.738v2.4h4.738zm-4.738 7.2v-7.2h-2.368v7.2h2.368zm7.107 0v-7.2h-2.369v7.2h2.369zm-2.369 2.4v-2.4h-4.738v2.4h4.738zm7.106 0v-7.2h2.37v-2.4h-2.37V122h-2.368v12h2.368zm7.107 0v-12H45.9v4.8h-2.369v2.4h2.37v4.8h2.368zm6.648-4.644v-2.4h-4.28v2.4h4.28zM59.656 134v-4.8h2.369v-2.4h-2.37v-2.4h2.37V122h-4.738v12h2.369zm4.738-7.2v-2.4h-2.37v2.4h2.37zm7.106-2.4V122h-2.369v2.4H71.5zm-2.369 9.6v-4.8H71.5v4.8h2.369v-9.6H71.5v2.4h-2.369v-2.4h-2.369v9.6h2.37zm14.213-9.6V122h-4.738v2.4h4.738zm-4.738 7.2v-7.2h-2.368v7.2h2.368zm4.738 2.4v-2.4h-4.738v2.4h4.738zm4.738 0v-4.8h2.369v-2.4h-2.37V122h-2.368v12h2.369zm4.737-7.2V122h-2.368v4.8h2.368zm0 7.2v-4.8h-2.368v4.8h2.368zm6.649-4.644v-2.4h-4.28v2.4h4.28zm4.737 4.644v-7.2h2.37v-2.4h-2.37V122h-2.368v12h2.368zm9.476 0v-12h-2.37v2.4h-2.368v2.4h2.369v7.2h2.369zm-4.743-4.8v-2.4h-2.369v2.4h2.369zm11.85-4.8V122h-2.37v2.4h2.37zm-2.37 9.6v-4.8h2.37v4.8h2.368v-9.6h-2.369v2.4h-2.369v-2.4h-2.369v9.6h2.37zm9.476 0v-7.2h2.368v-2.4h-2.368V122h-2.37v12h2.37zm7.106 0v-12h-2.369v4.8h-2.369v2.4h2.37v4.8H135z' /%3E%3C/g%3E%3C/svg%3E";

const placeholder_preview = "data:image/svg+xml,%3Csvg width='1280' height='800' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-opacity='0.1' d='M0 0h1280v800H0z'/%3E%3Ctext font-family='Arial, Helvetica, sans-serif' font-size='70' font-weight='bold' fill='%235D4B4B'%3E%3Ctspan x='314.511' y='425'%3EDrag an image here%3C/tspan%3E%3C/text%3E%3C/svg%3E"
    // `<svg width="1280" height="800" xmlns="http://www.w3.org/2000/svg"><path fill-opacity=".1" d="M0 0h1280v800H0z"/><text font-family="Arial, Helvetica, sans-serif" font-size="70" font-weight="bold" fill="#5D4B4B"><tspan x="314.511" y="425">Drag an image here</tspan></text></svg>`
// const MIconTemplate = {
//     'path': 'icon_1.svg',
//     'name': 'Empty icon',
//     'tags': []
// };

window.placeholder_preview = placeholder_preview;
window.emitr = ELGEventEmitter;
window.emtr = new ELGEventEmitter();

export class ESDIcon extends ELGEventEmitter {
    constructor (options) {
        super('[ESDIcon] :', (options && options.debug || false));
        this.displayName = '';
        this.zip = options.zip || null;
        this.file = options.file || null;
        this.src = '';
        this.objectURL = null;
        
    } 
    
}

export class ESDIconPack extends ELGEventEmitter {
    // debouncedEmit = Utils.debounce(this.emit, 100);
    debouncedEmit = Utils.debounce((fn) => {
        if(typeof fn === 'function') fn();
    }, 600);
    __uid = '';
    constructor (options) {
        super('[ESDIconPack] :', (options && options.debug || false));
        this.init();
    }

    init() {
        this.__iconsToAdd = [];
        this.__iconAsDataURL = null;
        this.__iconsjson = [];
        this.__sortState = '';
        this.readOnly = false;
        
        this.forceThumbnail = false;
        this.icons = [];
        this.esdIcons = [];
        this.previews = [placeholder_preview, placeholder_preview, placeholder_preview];
        // this.icon = "css/blue.svg";
        // this.icon = 'data:image/svg+xml,%3Csvg width=\'144\' height=\'144\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath fill=\'%23FF0000\' d=\'M0 0h144v144H0z\' fill-rule=\'evenodd\'/%3E%3C/svg%3E';
        // this.icon = "data:image/svg+xml,%3Csvg viewBox='0 0 262 201' version='1.1' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath opacity='1' d='M102.5 0c29.0051 0 55.1963 11.8125 73.8426 30.7988l5.8497-5.7717 79.4678 78.4118-79.4678 78.4119-8.8418-8.7252C154.9443 190.3928 129.9855 201 102.5 201 45.8908 201 0 156.0046 0 100.5S45.8908 0 102.5 0zm0 20C56.9365 20 20 56.265 20 101s36.9365 81 82.5 81c22.1351 0 42.2342-8.5589 57.0513-22.4898l-56.8269-56.0713 59.306-58.5177C147.0166 29.5613 125.8956 20 102.5 20z' fill='%235e6271' stroke='none' stroke-width='1' fill-rule='evenodd'/%3E%3C/svg%3E";
        this.icon = placeholder_preview;
        this.uid = '';
        this.lazy = [];
        this.manifest = new ESDIconPackManifest({Author: 'Elgato Systems', iconPack: this});
        this.updated = 0;
    }

    set icon(value) {
        // console.log("------  ESDIconPack: set icon ----", value);
        if(value instanceof File) {
            if(value.type.startsWith('image')) {
                this.icon = URL.createObjectURL(value);  // this calls itself, but the new input value is an object url
            }
        } else {
            this.__icon = value;
        }
        this.getIconAsDataUrl().then(du => this.__iconAsDataURL = du);
    }

    get icon() {
        return this.__icon;
    }

    set license(value) {
        this.manifest.license = value;
        this.updated = Date.now();
    }

    get license() {
        console.log('i:license:', this.manifest.license);
        return this.manifest.license;
    }

    set uid(value) {
        // console.log('setting uid:', value);
        // if(value !== this.__uid) {
        //     this.emit('uidChanged', value);
        // }
        this.__uid = value;
        this.emit('uidChanged', value);
    }

    get uid() {
        return this.__uid;
    }

    getIconAsDataUrl() {
        return Utils.fetchXhr(this.__icon, 'blob').then(d => d.blob()).then(b => {
            return Utils.fetchFile(b);
        });
    }

    set iconsjson(value) {
        if(Array.isArray(value)) {
            // console.log('setting iconsjson to ', value);
            return this.setMeta('iconsjson', value);
        }
        const f = this.getFileObj(value);
        if(f) {
            return Utils.fetchFile(f, 'text').then(inData => {
                let data = Utils.parseJson(inData, (catchedErr) => {console.log('Error parsing data', catchedErr, inData);}) || {};
                if(Array.isArray(data)) {
                    // this.setMeta('iconsjson', data);
                    this.iconsjson = data;
                }
            });
        }
    }

    get iconsjson() {
        return this.__iconsjson;
    }

    getSelected() {
        return this.icons.filter(i => i.isSelected);
    }

    setMeta(prop, value) {
        this[`__${prop}`] = value;
    }

    getMeta(prop) {
        return this[`__${prop}`] || {};
    }
    
    isPreview(f) {
        return f === placeholder_preview;
    }
    
    insertItemsAtIndex(arr, index, items) {
        // console.log('insertItemsAtIndex', arr, index, items);
        return [...arr.slice(0, index), ...items, ...arr.slice(index)];
    }
    
    insertItemAtIndex(arr, index, item) {
        // console.log('insertItemsAtIndex', arr, index, items);
        return [...arr.slice(0, index), item, ...arr.slice(index)];
    }
    
    replaceItemAtIndex(arr, index, item) {
        const idx = index < 1 ? 0 : index;
        return [...arr.slice(0, idx), item, ...arr.slice(idx+1)];
    }
    replacePreviewAtIndex(index, item) {
        this.previews = this.replaceItemAtIndex(this.previews, index, item);
    }
    
    logPreviewNames(msg) {
        console.log(msg, this.previews.map(p => p.file ? p.file.name : 'placeholder'));
    }
    
    swapPreviews(from, to) {
        const fromItem = this.previews[from];
        const toItem = this.previews[to];
        this.replacePreviewAtIndex(to, fromItem);
        this.replacePreviewAtIndex(from, toItem);
    }
    insertPreviewAtIndex(index, preview) {
        this.previews = this.insertItemAtIndex(this.previews, index, preview);
    }
    addPreview(f, idx) {
        const foundPlaceHolderIndex = this.previews.indexOf(placeholder_preview);
        if((idx != undefined) && idx >= 0 && idx < this.previews.length) {
            this.replacePreviewAtIndex(idx, f);
        } else if(foundPlaceHolderIndex > -1) {
            this.replacePreviewAtIndex(foundPlaceHolderIndex, f);
            this.sortPreviews();
        } else {
            this.previews.push(f);
            while(this.previews.length > 3) {
                this.previews.pop();
            }
            this.sortPreviews();
        }
    }
    
    sortPreviews() {
        this.previews.sort((a, b) => {
            if(!a.name || !b.name) return 1;
            return a.name.localeCompare(b.name);
        });
    }
    
    removePreview(f, removeAll = false) {
        if(removeAll) {
            // this.previews.splice(0, this.previews.length);
            this.previews = [placeholder_preview, placeholder_preview, placeholder_preview];
        } else {
            const index = this.previews.indexOf(f);
            if(index > -1) {
                this.previews.splice(index, 1);
                this.previews.push(placeholder_preview);
                // this.previews[index] = placeholder_preview;
            }
        }
    }

    removeId() {
        this.uid = '';
    }
    
    cleanPreviewsFromPlaceholders(inArr) {
        const arr = inArr || this.previews;
        for(let i = arr.length - 1;i >= 0;i--) {
            if(arr[i] == placeholder_preview) {
                arr.splice(i, 1);
            }
        }
        return arr;
    }

    hasIconsJson() {
        return this.__iconsjson.length;
    }
    
    readManifest(f) {
        return Utils.fetchFile(f, 'text').then(inData => {
            console.log('ESDIconPack:readManifest', f, inData);
            let data = Utils.parseJson(inData, (catchedErr) => {console.log('Error parsing data', catchedErr, inData);}) || {};
            // return Object.entries(manifest).map(props => {
            //     iconPack[props[0].toLowerCase()] = props[1];
            // });
            Object.assign(this.manifest, data);
            this.__manifestFilePath = f.fullPath || f.name || '';
            return this;
        });
    }
    
    setManifestFromJson(jsn) {
        if(typeof jsn == 'object') {
            jsn.iconPack = this;
            this.manifest = new ESDIconPackManifest(jsn);
        }
    }
    
    setIconPackIcon(evt) {
        let droppedFiles = evt.dataTransfer.files;
        if(!droppedFiles) return;
        this.setIcon(droppedFiles[0]);
    }

    isGif(f) {
        return f.type === 'image/gif';
    }
    setIcon(inFile) {
        if(!inFile) return;
        const f = this.getFileObj(inFile);
        if(f.type === 'image/gif') {
            this.createThumbnail(f).then(fl => {
                this.icon = fl.thumbNail;
                this.manifest.Icon = 'icon.png';
            }).catch(err => {
                console.log('Error creating thumbnail:', err);
                return;
            });
        } else {
            this.icon = f;
            const fa = f.name.split('.');
            f.suffix = fa.pop();
            this.manifest.Icon = `icon.${f.suffix}`;
        }
    }

    addIconAtIndex(f, idx, ipIcon) {
        this.icons.splice(idx, 0, f);
        if(!this.icon) this.icon = ipIcon;
    }

    loadThumbnailThreaded() {
        var ms = 1;
        setTimeout(() => {
            const f = this.__iconsToAdd.shift();
            if(!f.hasThumbnail) {
                this.createThumbnail(f.file).then(fl => {
                    f.thumbNail = fl.thumbNail;
                }).then(() => {
                    if(this.__iconsToAdd.length) {
                        this.loadThumbnailThreaded(this.__iconsToAdd);
                    }
                }).catch(err => {
                    console.log('Error creating thumbnail:', err, f);
                });
            }

            if(!this.__iconsToAdd.length) {
                this.updated = Date.now();
                this.emit('showMessage', '');
                // this.emit('thumbnailsLoaded');
                this.debouncedEmit(() => {
                    this.emit('thumbnailsLoaded');
                });
            }
        }, ms);
    }
    
    sortIconPack() {
       const arr = this.__iconsjson;
       this.icons.sort((a, b) => {
            return arr.findIndex(o => o.path == a.file.name) > arr.findIndex(o => o.path == b.file.name) ? 1 :-1;
        });
    }
    
    addIconT(f) {
         setTimeout(() => {
             this.addIcon(f);
            }, 0);
    }

    addIcon(f) {
        // this.esdIcons.push(new ESDIcon(f));
        // eslint-disable-next-line
        if(!f.file) return;
        
        const t = this.__iconsjson.find(i => f.file.name == i.path);
        f.tags = t ? Utils.tagify(t.tags) : [];
        if(t) {
            if(t.name !== '') f.name = t.name;
        }
        // this.icons.splice(idx, 0, f);
        
        this.icons.push(f);
        //        const iconsArray = this.__iconsjson;
    //    this.icons.sort((a, b) => {
    //         return iconsArray.findIndex(o => o.path == a.file.name) >  iconsArray.findIndex(o => o.path == b.file.name) ? 1 : -1;
    //     });
    
        this.sortIconPack();
                
        if(f.suffix == 'gif' || f.file.type === 'image/gif') {
            if(f.zip && f.zip.thumbNail) {
                return;
            }
            if(!f.thumbNail || (typeof f.thumbNail == 'string' && f.thumbNail.startsWith('data:image/svg+xml'))) {
                this.emit("showMessage", 'Updating thumbnails...');
                this.__iconsToAdd.push(f);
                this.loadThumbnailThreaded();
            }

            // setTimeout(() => {
            // this.createThumbnail(f.file).then(fl => {
            //     this.updated = Date.now();
            //     f.thumbNail = fl.thumbNail;
            // });
            // }, 0);
        }

    }

    addIconOld(f) {
        const idx = this.icons.length;
        if(!f.file) return;
        const t = this.__iconsjson.find(i => f.file.name == i.path);
        f.tags = t ? Utils.tagify(t.tags) : [];

        if(t) {
            if(t.name !== '') f.name = t.name;
        }
        if(f.file.type === 'image/gif') {
            this.createThumbnail(f.file).then(fl => {
                f.thumbNail = fl.thumbNail;
                this.icons.splice(idx, 0, f);
                if(!this.icon) this.icon = f.thumbNail;
            });
        } else {
            this.icons.splice(idx, 0, f);

            if(!this.icon) {
                if(this.forceThumbnail) {
                    this.createThumbnail(f.file).then(fl => {
                        f.thumbNail = fl.thumbNail;
                        if(!this.icon) this.icon = f.thumbNail;
                    });
                } else {
                    // if(!this.icon) this.icon = f.objectURL;
                }
            }
            // this.addIconAtIndex(f, idx, f.objectURL);
        }
        // this.verifyIcon(f, idx);
    }

    removeIcon(f) {
        if(f == 'all') {
            this.icons.splice(0, this.icons.length);
        } else {
            const index = this.icons.indexOf(f);
            console.log('ESDIconPack::removeIcon...', index, f.fileName || f.name, f);

            if(index > -1) {
                this.icons.splice(index, 1);
            }
        }
    }

    compile() {
        const data = {
            manifest: this.manifest.toJSON(),
            icons: this.createIconList()
        };
        console.log('ESDIconPack', data);
        return data;
    }
    // createAllThumbnails() {
    //     this.icons.forEach(icn => {
    //         const f = this.getFileObj(icn);
    //         if(!f.thumbNail) {
    //             this.createThumbnail(f);
    //         }
    //     });
    // }
    
    createThumbnail(f) {
        const l = new ESDImageScaler();
        return l.loadImage(f).then(dataUrl => {
            // console.log('createThumbnail:', f);
            f.thumbNail = dataUrl;
            return f;
        });
    }
    createIconList() {
        return this.icons.map(f => {
            const fileNameWithLowerCaseExtension = Utils.getFilenameWithLowerCaseExtension(f.file.name);
            return {
                path: fileNameWithLowerCaseExtension,
                name: f.name,
                tags: Utils.tagify(f.tags)
            };
        });
    }
   
    readFromFileObject(f) {
        // return readFileP(f).then(inData => {
        return Utils.fetchFile(f, 'text').then(inData => {
            let data = Utils.parseJson(inData, (catchedErr) => {console.log('Error parsing data', catchedErr, inData);}) || {};
            console.log('ICONPACK DATA:', data, Array.isArray(data));
            if(Array.isArray(data)) {
                data.map(icn => this.addIcon(icn));
            }
            // Object.assign(this, data);
        });
    }


    getFileObj(f) {
        if(f instanceof File) {
            return f;
        } else if(f.file && f.file instanceof File) {
            return f.file;
        } else if(f.fileObject && f.fileObject instanceof File) {
            return f.fileObject;
        }
    }


    /**
     * Verfiy icons
     */

    addStatus(icn, prop, value) {
        // eslint-disable-next-line
        if(!icn._status.hasOwnProperty('tips')) {icn._status.tips = {};};
        icn._status.tips[prop] = value;
    }

    verifyAllIcons() {
        this.icons.map(this.verifyIcon);
    }

    sortIcons(sortField) {
        if(['fileName', 'name', 'fullPath'].includes(sortField)) {

            const asc = (a, b) => [a[sortField].localeCompare(b[sortField])];
            const desc = (a, b) => [b[sortField].localeCompare(a[sortField])];

            let sortFn = asc;

            if(this.__sortState == sortField) {
                sortFn = desc;
                this.__sortState = '';
            } else {
                this.__sortState = sortField;
            }

            this.icons.sort((a, b) => {
                return sortFn(a, b);
            });
        }
    }
    
    checkIcons() {
        const arr = [...this.icons];
        this.processThreaded(arr, this.verifyIcon);
    }

    verifyIcon(icn, i) {
        if(icn) {
            if(icn.file && !icn.objectURL) {
                console.log('verifyIcon.. creating objectURL', icn, i);
                icn.objectURL = URL.createObjectURL(icn.file);
            }
            if(!icn._status) icn._status = {};
            icn._status['name'] = icn.name != '' ? 'isOK' : 'isError';

            if(icn.objectURL) {
                Utils.loadImageData(icn.objectURL, (img) => {
                    icn.imageinfo = `w:${img.naturalWidth} h:${img.naturalHeight} (${Math.floor(icn.file.size / 1024)} kb)`; // add icon info file.size | kb }} kb
                    icn._status['imageinfo'] =
                        img.naturalWidth % MRequiredSizeFactor === 0 &&
                        img.naturalHeight % MRequiredSizeFactor === 0;
                    icn.checked = true;
                    if(
                        img.naturalWidth % MRequiredSizeFactor !== 0 ||
                        img.naturalHeight % MRequiredSizeFactor !== 0
                    ) {
                        icn.alt =
                            'To avoid scaling or blurred edges, image width or height should be a multiple of 36';
                        this.addStatus(icn, 'imageinfo', icn.alt);
                    }
                });
            }
        }
    }
    
 exportIconPack() {

    this.emit('message', {message: 'Preparing icon pack...', loading: true, });

    const streamDeckIconPackExtension = 'streamDeckIconPack';  // 'zip'
    const suffixMap = {'svg+xml': 'svg'};
    const zip = new JSZip();

    const iconPackBundleID = this.uid;
    const iconPackBundleName = `${iconPackBundleID}.sdIconPack`;

    const baseFolder = zip.folder(iconPackBundleName);  // create base folder containing the GUID with extension 'sdProfile'
    const iconsFolder = zip.folder(iconPackBundleName + '/icons');
    const previewsFolder = zip.folder(iconPackBundleName + '/previews');

    const icons = this.createIconList();
    baseFolder.file('icons.json', JSON.stringify(icons, null, 4)); // create icons.json

    const isDataUrlMatches = this.__iconAsDataURL.match(/^data:image\/(png|jpg|tiff|jpeg|svg\+xml);base64,/);

    let iconName = 'icon.png';
    let fd;

    if(isDataUrlMatches) {
        iconName = `icon.${suffixMap[isDataUrlMatches[1]] || isDataUrlMatches[1]}`;
        fd = this.__iconAsDataURL.replace(/^data:image\/(png|jpg|tiff|jpeg|svg\+xml);base64,/, '');  //+++andy unify regex
    } else {
        fd = this.icon.replace(/^data:image\/(png|jpg|tiff|jpeg|svg\+xml);base64,/, '');
    }

    baseFolder.file(iconName, fd, {base64: true});
    this.manifest.Icon = iconName;

    baseFolder.file('manifest.json', this.manifest.toString());   // create manifest.json
    baseFolder.file('license.txt', this.manifest.license);

    // (async () => {
    const thumbP = [];

    const allP = this.icons.map(f => {
        // const isGif = f.file ? f.file.type === 'image/gif' : f.suffix == 'gif';
        const isGif = f.suffix == 'gif' ? true : f.file ? f.file.type === 'image/gif' : f.fileName.endsWith('gif');
        const fileNameWithLowerCaseExtension = Utils.getFilenameWithLowerCaseExtension(f.file.name);
        if(isGif) {
            if(f.thumbNail) {
                thumbP.push(f);
            } else if(f.zip && f.zip.thumbNail) {
                // console.log("adding zipped entry", fileNameWithLowerCaseExtension);
                return f.zip.thumbNail.async("uint8array").then(function(data) {
                    return iconsFolder.file(fileNameWithLowerCaseExtension, data, {binary: true});
                });
            }
        }
        if(f.zip && f.zip.zippedFile) {
            // console.log("adding FILE entry", fileNameWithLowerCaseExtension);
            return f.zip.zippedFile.async("uint8array").then(function(data) {
                return iconsFolder.file(fileNameWithLowerCaseExtension, data, {binary: true});
            });
        }
        return Utils.fetchFile(f.file, 'arraybuffer').then(function(data) {
            return iconsFolder.file(fileNameWithLowerCaseExtension, data, {binary: true});
        });
    });

    if(thumbP.length) {
        this.emit({message: 'Converting thumbNails...'});
    }

    // convert from dataUrl to base64 by stripping the dataUrl header
     Object.values(thumbP).map(f => {
        

        if(f.thumbNail && (f.thumbNail.file instanceof File)) {
            allP.push(Utils.fetchFile(f.thumbNail.file, 'arraybuffer').then(function(data) {
                const thumbnailNameWithLowerCaseExtension = Utils.getFilenameWithLowerCaseExtension(f.thumbNail.file.name);
                return iconsFolder.file(thumbnailNameWithLowerCaseExtension, data, {binary: true});
            }));
        } else if(f.zip && f.zip.thumbNail) {
            const name = f.zip.thumbNail.name.split('/').pop();
            allP.push(f.zip.thumbNail.async("uint8array").then(data => {
                return iconsFolder.file(name, data, {binary: true});
            }));
        } else {
            const fileNameWithLowerCaseExtension = Utils.getFilenameWithLowerCaseExtension(f.file.name);
            const fd = f.thumbNail.replace(/^data:image\/(png|jpg|tiff|jpeg|svg+xml);base64,/, '');
            allP.push(iconsFolder.file(fileNameWithLowerCaseExtension.replace('.gif', '.png'), fd, {base64: true}));
        }
    });
    
     const cleanedPreviews = this.cleanPreviewsFromPlaceholders(this.previews);

     if(cleanedPreviews.length) {
         this.emit('message', {message: 'Adding preview images...'});
         
           allP.push(...cleanedPreviews.map(f => {
               if(f.zip && f.zip.zippedFile) {
                   const name = f.zip.zippedFile.name.split('/').pop();
                   return f.zip.zippedFile.async("uint8array").then(data => {
                         return previewsFolder.file(name, data, {binary: true});
                     });
                 }
                 return Utils.fetchFile(f.file, 'arraybuffer').then(function(data) {
                     return previewsFolder.file(f.file.name, data, {binary: true});
                 });
             }));
         
         
     }

     Promise.all(allP).then(data => {
         console.log("generating zip", data);
         this.emit('message', {message: 'Generating icon pack...'});
         zip.generateAsync({type: 'blob'}).then((content) => {
            this.emit('message', {message: '', loading: false});
             saveAs(content, `${iconPackBundleID}.${streamDeckIconPackExtension}`);
        });
    });
    // })();
}

  processThreaded(arr, _cb) {
      console.log("processThreaded", arr ? arr.length : 0);
        var ms = 200;
        setTimeout(() => {
            const curIcon = arr.shift();
            console.log('Array length ', arr.length);
            if(_cb) _cb(curIcon);
            if(arr.length) {
                this.processThreaded(arr, _cb);
            }
        }, ms);
    }

    // loadThreaded() {
    //     var ms = 5;
    //     var timerId = setTimeout(() => {
    //         const curIcon = this.__iconsToAdd.shift();
    //         console.log(curIcon.file.name, this.__iconsToAdd.length);
    //         this.addIconThreaded(curIcon);
    //         if(this.__iconsToAdd.length) {
    //             this.loadThreaded(this.__iconsToAdd);
    //         }
    //     }, ms);
    // }

    // addIcon(f) {
    //     if(!f.file) return;
    //     this.__iconsToAdd.push(f);
    //     this.loadThreaded();
    // }
    
}
